module.exports = __webpack_public_path__ + "static/media/78.e4c7d896.png";